// Water User Constants

// Cities
export const METRICS_URL = `/api/metric`;
export const ALL_CITIES_URL = `${METRICS_URL}/all_cities`;
export const CITY_METRICS_URL = `${METRICS_URL}/cities_metric`;
export const CITY_WATER_SOURCES_URL = `${METRICS_URL}/city_water_sources`;
export const ALL_CITY_METRICS_URL = `${METRICS_URL}/all_cities_metric`;
export const CITY_POPULATION_URL = `${METRICS_URL}/city_population`;

export const CITY_URL = `/api/city`
export const ALL_CITIES_WATER_USE = `${CITY_URL}/all_cities_water_use`;
// Tribes
export const TRIBE_URL = `/api/tribe`;
export const ALL_TRIBES_URL = `${TRIBE_URL}/all_tribes`;
export const TRIBES_METRICS_URL = `${METRICS_URL}/tribe_metric`;

// Tribal Shortage
export const TRIBAL_SHORTAGE_URL = `/api/tribal_shortage`;
export const GET_SHORTAGE_BY_TRIBE = `${TRIBAL_SHORTAGE_URL}/shortage_by_tribe`

// Agriculture
export const ALL_AGRICULTURE_URL = `${METRICS_URL}/all_agriculture`;
export const AGRICULTURE_METRICS_URL = `${METRICS_URL}/agriculture_metric`;

export const AGRICULTURE_URL = `/api/agriculture`;
export const GET_ALL_DISTRICT_WATER = `${AGRICULTURE_URL}/all_district_water`;
export const GET_ALL_DELIVERIES = `${AGRICULTURE_URL}/all_deliveries`;

// Indsutry
export const INDUSTRY_SHORTAGE_URL = `/api/industry_shortage`;
export const GET_SHORTAGE_BY_CATEGORY = `${INDUSTRY_SHORTAGE_URL}/shortage_by_category`
export const INDUSTRY_METRICS_URL = `/api/industry_metrics`;
export const GET_INDUSTRY_METRICS = `${INDUSTRY_METRICS_URL}/all_industry_metrics`